import { useEffect, useState } from 'react'
import { AppProps } from '../../App'
import MainWrapper from '../../components/MainWrapper';
import { useLocation, useNavigate } from 'react-router-dom';
import DatabaseAPI from './DatabaseAPI';
import AuthAPI from './AuthAPI';
import StorageAPI from './StorageAPI';
import Quickstart from './Quickstart';
import FunctionAPI from './FunctionAPI';
import Example1 from './Example1';

const Docs = (props: AppProps) => {
  
  const navigate = useNavigate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const query = new URLSearchParams(useLocation().search);
  const [apiOption, setApiOption] = useState<string>(query.get('doc') || 'get-started');
  
  useEffect(() => {
    if (
      query.get('d') && 
      query.get('d') !== 'get-started' &&
      query.get('d') !== 'auth' && 
      query.get('d') !== 'database' && 
      query.get('d') !== 'storage' && 
      query.get('d') !== 'function' &&
      query.get('d') !== 'example-1'
    ) {
      navigate(`/pagenotfound`);
      return;
    }
    setApiOption(query.get('d') as any || 'get-started');
    document.getElementsByTagName('main')?.[0].scrollTo({ top: 0 });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.get('d')]);

  return (
    <>
      <MainWrapper {...props} padding={0}>
        <div className='flex-1 px-4'>
          {apiOption === 'get-started' ? <Quickstart />
            : apiOption === 'auth' ? <AuthAPI />
            : apiOption === 'database' ? <DatabaseAPI />
            : apiOption === 'storage' ? <StorageAPI />
            : apiOption === 'function' ? <FunctionAPI />
            : apiOption === 'example-1' ? <Example1 /> : <></>}
        </div>
      </MainWrapper>
    </>
  )
}

export default Docs